import React from 'react';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Collapse, Row, Col, Typography, message } from 'antd';

// MUI Icons
// import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CloseIcon from '@mui/icons-material/Close';
import PushPinIcon from '@mui/icons-material/PushPin';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import VideocamIcon from '@mui/icons-material/Videocam';

// Constants
import { ROUTES } from '../../../../constants';

// Components
import GeoLocation from '../../../GeoLocation';

// Services Library
import { TIME } from '../../../../services/util';
import { set_new_geofence_from_map } from '../../../../services/redux/actions/mapControl';
import { set_selected_live_camera_by_vid_request } from '../../../../services/redux/actions/liveCamera';


const { Panel } = Collapse;
const { Text } = Typography;

const TraceInformation2 = ({ item = {} }) => {
    // const {
    //     trace
    // } = props


    const navigate = useNavigate()
    const dispatch = useDispatch()

    const vehicles = useSelector(state => state.containers.v3.vehicles)
    const drivers = useSelector(state => state.containers.v3.drivers)
    const mapControl = useSelector(state => state.containers.v3.mapControl);

    const vehicleStatic = vehicles.staticsByID[item.vid] || {}

 
    return (
        <Card
        style={{ width: 350, borderRadius: 8, overflow: 'hidden' }}
        bodyStyle={{ padding: 0 }}
        >
            {/* Header Section */}
            <div style={{ 
                padding: '12px 16px', 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                borderBottom: '1px solid #f0f0f0'
            }}>
                {/* <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <WarningAmberIcon style={{ color: '#d433bc', fontSize: 20 }} />
                    { icon } */}
                    {/* <Text strong style={{ fontSize: 16 }}>{item.rule?.name}</Text> */}
                    <Text strong style={{ fontSize: 16 }}>Speed: {item.ecu_can_vehicle_speed || item.ecu_tach_vehicle_speed || item.speed || '-'} km/h</Text>
                {/* </div> */}
                <CloseIcon style={{ fontSize: 18, color: '#999', cursor: 'pointer' }} />
            </div>

            {/* Accordion / Collapse Section */}
            <Collapse
                ghost
                expandIconPosition="end"
                defaultActiveKey={['1']}
                style={{ backgroundColor: '#fff' }}
            >
                {/* Section 1: Vehicle & Driver */}
                <Panel 
                    header={<Text type="secondary" strong style={{ fontSize: 12 }}>VEHICLE & DRIVER</Text>} 
                    key="1"
                >
                <div style={{ paddingLeft: 12 }}>
                    <div style={{ marginBottom: 12 }}>
                    <Text type="secondary" style={{ fontSize: 11, display: 'block' }}>VEHICLE</Text>
                    <Text strong>{vehicleStatic?.plate || '-'}</Text>
                    </div>
                    <div style={{ marginBottom: 12 }}>
                    <Text type="secondary" style={{ fontSize: 11, display: 'block' }}>DRIVER</Text>
                    <Text strong>{drivers.byID[vehicleStatic.drvid]?.name || '-'}</Text>
                    </div>
                    <div>
                    <Text type="secondary" style={{ fontSize: 11, display: 'block' }}>DRIVER (S)</Text>
                    <Text strong>{drivers.byID[vehicleStatic.sub_drvid]?.name || '-'}</Text>
                    </div>
                </div>
                </Panel>

                {/* Section 2: Time & Location */}
                <Panel 
                    header={<Text type="secondary" strong style={{ fontSize: 12 }}>TIME & LOCATION</Text>} 
                    key="2"
                >
                    <div style={{ paddingLeft: 12 }}>
                        <div style={{ marginBottom: 8 }}>
                            <Text type="secondary" style={{ fontSize: 11, display: 'block' }}>TIMESTAMP</Text>
                            <Text>{TIME.parseTime(item.vehicleTime)}</Text>
                        </div>
                        <div style={{ marginBottom: 8 }}>
                            <Text type="secondary" style={{ fontSize: 11, display: 'block' }}>COORDINATES</Text>
                            <GeoLocation location={item.location}/>
                        </div>
                        <div style={{ display: 'flex', gap: 40 }}>
                        <div>
                            <Text type="secondary" style={{ fontSize: 11, display: 'block' }}>HEADING</Text>
                            <Text>{item.heading || '-'}</Text>
                        </div>
                        <div>
                            <Text type="secondary" style={{ fontSize: 11, display: 'block' }}>ALTITUDE</Text>
                            <Text>{item.altitude}</Text>
                        </div>
                        </div>
                    </div>
                </Panel>

                {/* Section 3: Signal & Device */}
                <Panel 
                    header={<Text type="secondary" strong style={{ fontSize: 12 }}>SIGNAL & DEVICE</Text>} 
                    key="3"
                >
                    <div style={{ paddingLeft: 12 }}>
                        <div style={{ marginBottom: 8 }}>
                            <Text type="secondary" style={{ fontSize: 11, display: 'block' }}>CONNECTIVITY STATUS</Text>
                            <Text>{item.connectivity || '-'}</Text>
                        </div>
                        <div style={{ marginBottom: 8 }}>
                            <Text type="secondary" style={{ fontSize: 11, display: 'block' }}>GPS STATUS</Text>
                            <Text>{item.gnss_status || '-'}</Text>
                        </div>
                        <div style={{ display: 'flex', gap: 40 }}>
                            <div>
                                <Text type="secondary" style={{ fontSize: 11, display: 'block' }}>CELL STRENGTH</Text>
                                <Text>{item.cell_signal || '-'}</Text>
                            </div>
                            <div>
                                <Text type="secondary" style={{ fontSize: 11, display: 'block' }}>ENGINE IGNITION</Text>
                                <Text>{item.ignition || '-'}</Text>
                            </div>
                            <div>
                                <Text type="secondary" style={{ fontSize: 11, display: 'block' }}>DEVICE BATTERY LEVEL</Text>
                                <Text>{item.pwr_int_lvl || '-'}</Text>
                            </div>
                            <div>
                                <Text type="secondary" style={{ fontSize: 11, display: 'block' }}>EXTERNAL FOOTAGE</Text>
                                <Text>{item.pwr_ext_v || '-'}</Text>
                            </div>
                        </div>
                    </div>
                </Panel>
            </Collapse>

            {/* Footer Actions Section */}
            <div style={{ padding: '16px', borderTop: '1px solid #f0f0f0' }}>
                <Row gutter={8}>
                 <Col span={8} style={{ textAlign: 'center' }}>
                        <div 
                            aria-hidden="true"
                            onClick = {() => {
                                const currCoor = {
                                    lat: parseFloat(item.location.lat),
                                    lng: parseFloat(item.location.lon)
                                }
    
                                dispatch(set_new_geofence_from_map({
                                    ...mapControl.geofence,
                                    coordinates: [currCoor],
                                    radius: 100,
                                    // name: address?.split(',')[0]
                                }));
    
                                navigate(ROUTES.MODULE_ROUTE.GEOFENCE_MANAGEMENT_POI_CREATE, { 'name':  ''});
                            }}
                            style={{ padding: '12px 0', border: '.2px solid #c3c3c3', textAlign: 'center', cursor: 'pointer' }}
                        >
                            <PushPinIcon />
                            <Text style={{ fontSize: 11, display: 'block' }}>Add as POI</Text>
                        </div>
                    </Col>
                    <Col span={8}>
                        <div
                            aria-hidden="true"
                            style={{ padding: '12px 0', border: '.2px solid #c3c3c3', textAlign: 'center', cursor: 'pointer' }}
                        >
                            <PlayCircleOutlineIcon />
                            <Text style={{ fontSize: 11, display: 'block' }}>View Playback</Text>
                        </div>
                    </Col>
                    <Col span={8}>
                        <div
                            aria-hidden="true"
                            style={{ padding: '12px 0', border: '.2px solid #c3c3c3', textAlign: 'center', cursor: 'pointer' }}
                            onClick = {() => {
                                // dispatch(remove_enabled_vehicle_pop_up(thisVehicle.vid));

                                if(!item.IsOnline) {
                                    message.warning('We are unable to retrieve playback. MDVR is currently offline.')
                                }
                                else if(item.mdvrid && item.IsOnline) {
                                    dispatch(set_selected_live_camera_by_vid_request(item.vid, item.mdvrid, true))
                                }
                                else {
                                    message.error('Playback unsuccessful. Vehicle is not assigned with MDVR')
                                }
                            }}
                        >
                            <VideocamIcon />
                            <Text style={{ fontSize: 11, display: 'block' }}>Live Camera</Text>
                        </div>
                    </Col>
                </Row>
            </div>
        </Card>
    );
};

export default TraceInformation2;